<template>
  <div class="container">
    <el-row type="flex" align="middle" class="culture-container">
      <el-col :offset="4" :span="10">
        <el-row class="title">集成化家居产业型企业</el-row>
        <el-row
          class="content"
        >北京伯艺木门成立于1999年，是集研发、设计、生产、销售、服务于一体的生产企业，倡导“轻奢”家居理念，致力于打造以木门为中心的整木定制空间，产品涵盖木门、窗套、垭口、墙板类、柜类、线条类等。</el-row>
      </el-col>
      <el-col :offset="1" :span="9">
        <el-image src="static/images/allpepole.jpg" />
      </el-col>
    </el-row>
    <el-row class="category-container">
      <el-row>
        <el-col class="design-title" :span="9">
          <div class="english">PRODUCTSERIES</div>
          <div class="chinese">产品系列</div>
        </el-col>
        <el-col :span="13">
          <el-row type="flex" :gutter="8">
            <el-col v-for="(item,index) in this.categories" :key="index">
              <el-image @click="handtolist(item)" :src="item.pic" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <div class="evenmore" @click="goshoplist()">
            查看更多
            <i class="el-icon-arrow-right" style="margin-left: 248px;"></i>
          </div>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['categories'],
  methods: {
    handtolist(itemobj) {
      this.$router.push({
        path: itemobj.url
        // query: {
        //   productId: itemobj
        // }
      })
    },
    goshoplist() {
      this.$router.push({
        path: '/indexpage/productlist'
        // query: {
        //   productId: itemobj
        // }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.culture-container {
  background-color: #f8f8f8;
  padding-top: 96px;
  padding-bottom: 96px;
  .title {
    font-size: 27px;
    font-family: PingFang;
    // font-weight: bold;
    color: #000000;
    line-height: 26px;
  }
  .content {
    font-size: 18px;
    font-family: PingFang;
    line-height: 41px;
    margin-top: 64px;
  }
  .el-image {
    width: 400px;
  }
}
.category-container {
  padding-top: 96px;
  padding-bottom: 72px;
  background-color: white;
  .el-image {
    cursor: pointer;
  }
  .design-title {
    position: relative;
    .english {
      width: 150px;
      font-size: 18px;
      font-family: PingFang;
      // font-weight: bold;
      color: #898989;
      line-height: 27px;
      border-top: 2px solid #aaaaaa;
      position: relative;
      top: 66px;
      left: 322px;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg); /* IE 9 */
      -moz-transform: rotate(90deg); /* Firefox */
      -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
      -o-transform: rotate(90deg); /* Opera */
    }
    .chinese {
      width: 28px;
      // height: 141px;
      font-size: 30px;
      font-family: PingFang;
      // font-weight: bold;
      color: #000000;
      line-height: 38px;
      position: relative;
      top: -30px;
      left: 425px;
    }
  }

  .evenmore {
    font-size: 18px;
    line-height: 30px;
    width: 351px;
    height: 43px;
    border-bottom: 1px solid #aaaaaa;
    float: right;
    cursor: pointer;
    margin-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/advertise.vue